import { AuthContext } from 'context/AuthContext';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UIElementProps } from 'types/prop-types';
import '../../assets/styles/base.scss';
import { SimpleHeader } from './SimpleHeader';
import { useActivePhases } from 'hooks/useControlDate';

export function AppContainer({ children }: UIElementProps) {
    const { isAuthenticated, user } = useContext(AuthContext);
    const location = useLocation();
    const userName = user?.name ? user.name.split(" ")[0] : '';
    const phases = useActivePhases();

    // Páginas que possuem seu próprio header customizado
    const pagesWithCustomHeader = ['/listagem-inscricao-elbb','/home-public', '/home-elbb', '/iniciativas', '/iniciativas-elbb', '/minha-jornada', '/minha-jornada-elbb'];
    const shouldShowSimpleHeader = !phases.elbbInscriptionPeriod && (phases.elbbPreRegistration || phases.elbbConfirmation) && isAuthenticated && !pagesWithCustomHeader.includes(location.pathname);
    
    return (
      <div className="flex flex-col w-full min-h-screen">
        <>
          {shouldShowSimpleHeader && (
           <SimpleHeader title={'Prêmio ELBB'} userName={userName} />
          )}
          <div className={isAuthenticated ? "" : ""}>
            <div className={isAuthenticated ? "" : ""}>{children}</div>
          </div>
        </>
      </div>
    );
}
